import { Box, styled } from '@mui/material';

import { ganttFlightBoxHeight, ganttFlightBoxMarginTop } from '../gantt.constants';

const transitionDuration = '300ms';
export const GanttTurnaroundsBox = styled(Box)`
    position: relative;
    align-items: center;
    height: ${ganttFlightBoxHeight}px;
    margin-top: ${ganttFlightBoxMarginTop}px;
    flex-shrink: 0;
    user-select: none;
    transition: filter ${transitionDuration} ease-out, transform ${transitionDuration} ease-out;
    filter: drop-shadow(0px 0px 0px #00000000);
    transform: translateY(0);
`;
